module.exports = __webpack_public_path__ + "static/media/cornerMatTan95.12e514c6.png";